const rolesAndPermission = {
  Dashboard: {
    roles: [
      "super_admin",
      "asset_manager",
      "back_office_admin",
      "company_admin",
      "seller",
      "buyer",
      "transport_company",
      "finance_company"
    ]
  },
  Organizations: {
    roles: ["super_admin", "asset_manager"],
    subModule: [
      { module: "Organization List" },
      { module: "Buyer/Seller List" }
    ]
  },
  Assets: {
    roles: ["super_admin", "asset_manager"],
    subModule: [
      { module: "All Assets" },
      { module: "Assets Under Negotiation" }
    ]
  },
  Buying: {
    roles: ["seller", "buyer"],
    subModule: [
      { module: "All Assets" },
      { module: "Assets Under Negotiation" },
      { module: "Purchased Asset" },
      { module: "" },
      { module: "Want to Buy" }
    ]
  },
  Selling: {
    roles: ["seller"],
    subModule: [
      { module: "All Assets" },
      { module: "Assets Under Negotiation" },
      { module: "Sold Assets" }
    ]
  },
  "Become a Seller": { roles: ["buyer"] },
  Services: {
    roles: ["super_admin", "asset_manager", "buyer"],
    subModule: [
      { module: "Finance Companies" },
      { module: "Transportation Companies" }
    ]
  },
  Support: { roles: ["super_admin", "back_office_admin"] },
  Employees: { roles: ["super_admin", "company_admin"] },
  "Roles & Permissions": { roles: ["super_admin", "company_admin"] },
  "My Account": {
    roles: [
      "super_admin",
      "asset_manager",
      "back_office_admin",
      "company_admin",
      "seller",
      "buyer",
      "transport_company",
      "finance_company"
    ]
  },

  "Master Data": {
    roles: ["super_admin"],
    subModule: [
      { module: "Currencies" },
      { module: "World Data" },
      { module: "Assets Categories" }
    ]
  },

  "Organization Settings": {
    roles: ["company_admin"],
    subModule: [
      { module: "Manage Subscriptions" },
      { module: "Manage Organization Profile" },
      { module: "Manage Locations" }
    ]
  },
  "Become an Organization": {
    roles: ["buyer"]
  }
};

export const checkIsAllow = (moduleName, parent, array) => {
  let resultVal = null;
  if (array) {
    array.map(item => {
      if (moduleName === item.name && item.parent === parent) {
        if (item.status) {
          resultVal = item;
        }
      }

      return item;
    });
  }

  return resultVal;
};

export const checkIsAllowModule = moduleName => {
  const roles = JSON.parse(window.localStorage.getItem("roles"));
  // const user = JSON.parse(window.localStorage.getItem('user'));

  if (!roles) {
    return false;
  }

  if (roles && roles.length <= 0) {
    return false;
  }

  let isAllow, sub_module;
  roles.find(role => {
    if (rolesAndPermission[moduleName].roles.indexOf(role) > -1) {
      isAllow = rolesAndPermission[moduleName].roles.indexOf(role) > -1;
      sub_module = rolesAndPermission[moduleName].subModule;
    }

    return rolesAndPermission[moduleName].roles.indexOf(role) > -1;
  });
  return { isAllow, sub_module };
};
